import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="bg-atmosphere grain flex min-h-dvh flex-col items-center justify-center gap-5 px-6 text-center">
      <div className="relative z-10 flex flex-col items-center gap-5">
        <Logo size={56} />
        <div className="space-y-1.5">
          <p className="font-display text-6xl font-medium tracking-tight text-primary">404</p>
          <p className="text-sm text-muted-foreground">페이지를 찾을 수 없습니다.</p>
        </div>
        <Button asChild>
          <Link to="/admin">관리자 홈으로</Link>
        </Button>
      </div>
    </div>
  );
}
